module.exports = "#secondary-page-what-is-content{\n    z-index: 2; /* Makes sure content is beind the nav drawer*/\n}"